import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import Highlight from './Highlight';
import { userColor } from '../utils/userColor';

function initialsOf(agent) {
  if (!agent) return '—';
  return `${(agent.name || '')[0] || ''}${(agent.surname || '')[0] || ''}`.toUpperCase() || '—';
}

function fullNameOf(agent) {
  if (!agent) return '';
  return [agent.name, agent.surname].filter(Boolean).join(' ');
}

/**
 * Selettore assegnatario compatto (avatar + nominativo) apribile inline,
 * pensato per righe di tabella/kanban dove non si vuole aprire il dettaglio
 * del ticket solo per cambiare l'assegnatario.
 */
function AssigneePicker({ value, agents, onChange, disabled = false, terms, me = null }) {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const handleClickOutside = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const current = agents.find((a) => a.id === value) || null;
  // L'utente corrente si riconosce dal "(tu)" dopo il nome.
  const nameOf = (a) => (a.id === me ? `${fullNameOf(a)} (${t('tickets.you')})` : fullNameOf(a));

  const select = (agentId) => {
    setOpen(false);
    if (agentId !== (value || null)) onChange(agentId);
  };

  return (
    <div className="assignee-picker" ref={rootRef} onClick={(e) => e.stopPropagation()}>
      <button
        type="button"
        className="assignee-picker-trigger"
        onClick={() => !disabled && setOpen((o) => !o)}
        disabled={disabled}
      >
        <span className={'avatar avatar-sm' + (current ? '' : ' avatar-empty')} style={current ? { background: userColor(current) } : undefined}>{initialsOf(current)}</span>
        <span className="assignee-picker-name"><Highlight text={current ? nameOf(current) : t('tickets.unassigned')} terms={terms} /></span>
      </button>
      {open && (
        <div className="assignee-picker-menu">
          <button type="button" className="assignee-picker-option" onClick={() => select(null)}>
            <span className="avatar avatar-sm avatar-empty">—</span>
            <span>{t('tickets.unassigned')}</span>
          </button>
          {agents.map((a) => (
            <button key={a.id} type="button" className="assignee-picker-option" onClick={() => select(a.id)}>
              <span className="avatar avatar-sm" style={{ background: userColor(a) }}>{initialsOf(a)}</span>
              <span>{nameOf(a)}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default AssigneePicker;
